import CompanyQuoteWebsiteDisclosureInfo from './CompanyQuoteDisclosureWebsiteInfo'
export { CompanyQuoteWebsiteDisclosureInfo }
export default CompanyQuoteWebsiteDisclosureInfo
